// =============================================================================
// 404 NOT FOUND PAGE COMPONENT
// =============================================================================

import React from 'react';
import { Navbar, Footer } from '@/components/Layout';
import { ContentRenderer } from '@/components/ContentRenderer';
import { SEOHead } from '@/components/SEO';
import { notFoundPageComponents } from '@/data/legalPageContent';
import { navItems, footerLinks, socialLinks } from '@/data/homeContent';
import { seoData } from '@/data/seoData';
import { useNotFoundStatus } from '@/hooks/useHttpStatus';

export const NotFoundPage: React.FC = () => {
  const seo = seoData.notfound;
  
  // Set HTTP 404 status code for proper SEO and server responses
  useNotFoundStatus();
  
  return (
    <div className="not-found-page">
      <SEOHead
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        canonicalUrl={seo.canonicalUrl}
        noIndex={seo.noIndex}
      />
      
      <Navbar 
        brand="Alex Finger Consulting"
        navItems={navItems}
        showThemeSwitcher={false}
      />
      
      <main className="main-content">
        <ContentRenderer components={notFoundPageComponents} />
      </main>
      
      <Footer
        brand="Alex Finger Consulting"
        description="Web development and business strategy services. Transform your ideas into digital reality."
        links={footerLinks}
        socialLinks={socialLinks}
      />
    </div>
  );
};

